import React from 'react';
import { useTranslation } from 'react-i18next';
import AppNavBar from '../../components/AppNavBar';

export default function UrpassNavBar() {
  const [t] = useTranslation('global');

  return (
    <>
      <AppNavBar
        items={[
          { label: t('home.mycards'), url: 'cards' },
          { label: t('home.agencytickets'), url: 'urpass' },
        ]}
        selected={1}
      />
    </>
  );
}
